import { render } from "./ApplicationsPage.vue?vue&type=template&id=2a2474b6&scoped=true"
import script from "./ApplicationsPage.vue?vue&type=script&lang=js"
export * from "./ApplicationsPage.vue?vue&type=script&lang=js"

import "./ApplicationsPage.vue?vue&type=style&index=0&id=2a2474b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2474b6"]])

export default __exports__